import { render } from "./PregaPerNoi.vue?vue&type=template&id=f2b645b6&scoped=true"
import script from "./PregaPerNoi.vue?vue&type=script&lang=js"
export * from "./PregaPerNoi.vue?vue&type=script&lang=js"

import "./PregaPerNoi.vue?vue&type=style&index=0&id=f2b645b6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sciam\\Desktop\\Workspaces\\local\\workspace_vue\\mdv-webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2b645b6"]])

export default __exports__